import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, getCurrentInstance, watch } from 'vue';

import { useBilling } from '@/components/Billing/Billing.composables';
import { PaymentMethod } from '@/components/Billing/billing-types';
// @ts-ignore
import StripeCardInput from '@/components/Payment/Stripe/StripeCardInput.vue';
import AppTextField from '@/components/atoms/inputs/TextFields/AppTextField.vue';
import { BILLING_USAGE_SETTINGS_ROUTE_NAME } from '@/router/BillingUsage/billing-usage-router.const';
import { capitalizeWord } from '@/utils/language-service';

export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentInfoInput',
  props: {
    paymentMethod: null
  },
  emits: ["error", "loading", "card-valid-updated"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'error'): void;
	(e: 'loading', isLoading: boolean): void;
	(e: 'card-valid-updated', isCardValid: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	paymentMethod: PaymentMethod | null;
}



const { setPaymentMethod, getPaymentIntent } = useBilling();

const settingsRouteName = BILLING_USAGE_SETTINGS_ROUTE_NAME;

// @ts-ignore
const stripe = getCurrentInstance()?.proxy.$stripe;

const cardInputRef = ref();
const isCardValid = ref(false);
const fullName = ref(props.paymentMethod?.billing_details?.name || '');
const isCardFormValid = computed(() => isCardValid.value && fullName.value?.length > 0);
watch(isCardFormValid, (val) => emit('card-valid-updated', val));
const hasValidPaymentMethod = computed(() => props.paymentMethod?.type === 'card');

const cardEndingSentence = computed(() => {
	if (hasValidPaymentMethod.value) {
		return `${capitalizeWord(props.paymentMethod?.card.display_brand)} ending in ${props.paymentMethod?.card.last4}`;
	}
	return '';
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const generateCardToken = () => {
	// this will trigger the process, calledFromParent component
	emit('loading', true);
	cardInputRef.value?.submit();
};
const onTokenCreated = async (token: object) => {
	emit('loading', true);
	try {
		const intentResponse = await getPaymentIntent();
		const saveIntentResponse = await stripe.confirmCardSetup(intentResponse.intent.client_secret, {
			payment_method: {
				card: {
					// @ts-ignore
					token: token.id,
				},
			},
		});
		await setPaymentMethod({
			paymentMethodId: saveIntentResponse.setupIntent.payment_method,
			name: fullName.value,
		});
		emit('loading', false);
	} catch (e) {
		emit('error');
		console.error('error occurred while saving payment method', e);
	}
};

return { __sfc: true,emit, props, setPaymentMethod, getPaymentIntent, settingsRouteName, stripe, cardInputRef, isCardValid, fullName, isCardFormValid, hasValidPaymentMethod, cardEndingSentence, generateCardToken, onTokenCreated, StripeCardInput, AppTextField }
}

})